import {Queue} from "./Queue";
import TextTranslationClient, {isUnexpected} from "@azure-rest/ai-translation-text";
import {
    Language,
    RecognizableAndTranslatableLanguage,
    TranslatableAndSpeakableLanguage,
    TranslationResult
} from "./Configuration";

export class TranslationProcessor {

    private endpoint = 'https://api.cognitive.microsofttranslator.com';
    private apiKey;
    private region = "eastus";

    private pendingTranslationQueue: Queue<string>;
    private inputLanguage: RecognizableAndTranslatableLanguage;
    private outputLanguages: TranslatableAndSpeakableLanguage[];
    private outputLanguageIds: string;
    private onTranslationReady: (translationsReady: Map<Language, TranslationResult>) => void;

    private pollingInterval: NodeJS.Timer | undefined = undefined;

    private translationClient;

    constructor(translationKey: string, inputLanguage: RecognizableAndTranslatableLanguage,
                outputLanguages: TranslatableAndSpeakableLanguage[],
                onTranslationReady: (translationsReady: Map<Language, TranslationResult>) => void) {
        this.apiKey = translationKey;
        this.translationClient = TextTranslationClient(this.endpoint, {
            key: this.apiKey,
            region: this.region
        })

        this.pendingTranslationQueue = new Queue<string>();
        this.inputLanguage = inputLanguage;
        this.outputLanguages = outputLanguages;
        this.outputLanguageIds = outputLanguages.map(output => output.translationKey).join(",");
        this.onTranslationReady = onTranslationReady;
    }

    public start = (): void => {

        if (this.pollingInterval) {
            throw new Error("Cant start TranslationProcess");
        }

        this.pollingInterval = setInterval(() => {

            let textToTranslate = this.pendingTranslationQueue.dequeue();
            if (!!textToTranslate)
                //console.log("will translate", textToTranslate)
                this.translate(textToTranslate);

        }, 1000)
    }

    public stop = (): void => {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval)
            console.log("[Session Context] [4] Stopped Translation ")
        }
    }

    public enqueueText = (textToTranslate: string): void => {
        this.pendingTranslationQueue.enqueue(textToTranslate);
    }

    private translate = (text: string) => {

        console.log('[Translation Processor] Will translate...', text);
        this.translationClient.path("/translate")
            .post({
                body: [{text: text}],
                queryParameters: {
                    from: this.inputLanguage.recognitionKey.split("-")[0],//"en",
                    to: this.outputLanguageIds,//"es",
                }
            })
            .then(translateResponse => {

                const solveTranslationResponse = async () => {
                    if (isUnexpected(translateResponse)) {
                        throw translateResponse.body.error;
                    }

                    const translationResponseBody = translateResponse.body;
                    // console.log("SENT raw 0", translationResponseBody)
                    for (const translation of translationResponseBody) {
                        translation.translations.forEach(tr => {
                            // console.log("SENT raw 1", tr, translation)
                            console.log(
                                `Text was translated to: '${tr.to}' and the result is: '${tr.text}'.`
                            );
                        })

                        let parsedTranslations = new Map<Language, TranslationResult>();
                        translation.translations.forEach(tr => {
                            const lang = {id: tr.to} as Language;
                            // console.log("SENT raw 2", tr)
                            const translationResult = {
                                originalText: translation.sourceText || text || '',
                                translatedText: tr.text,
                                status: '',
                                language: lang
                            } as TranslationResult;
                            parsedTranslations.set(lang, translationResult);
                        });

                        this.onTranslationReady(parsedTranslations);
                    }
                };

                solveTranslationResponse();
            });
    }
}
